import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, CardTitle } from "reactstrap"
import DonutChart from "./DonutChart"
import API from "../../api/axios"

const MonthlyEarnings = () => {
  const [chartData, setChartData] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const response = await API.get(
        "/appointments/appointment-by-service",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setChartData(response.data)
    } catch (error) {
      console.error("Error fetching appointment data", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="h4 mb-4">Appointment by Service</CardTitle>

          <Row className="text-center mt-4">
            <div className="col-12">
              <p className="text-muted">
                Distribution of appointments per service
              </p>
            </div>
          </Row>

          <div dir="ltr">
            {loading ? (
              <p>Loading chart...</p>
            ) : (
              <DonutChart data={chartData} />
            )}
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarnings
